import React from "react";
import {
  Typography,
  makeStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import SubjectIcon from "@material-ui/icons/Subject";
import BookIcon from "@material-ui/icons/Book";
import CalculateIcon from "@mui/icons-material/Calculate";
import ScienceIcon from "@mui/icons-material/Science";
import BiotechIcon from "@mui/icons-material/Biotech";
import NumbersIcon from "@mui/icons-material/Numbers";
import PercentIcon from "@mui/icons-material/Percent";
import BusinessIcon from "@mui/icons-material/Business";
import TerrainIcon from "@mui/icons-material/Terrain";
import LanguageIcon from "@mui/icons-material/Language";
import PeopleIcon from "@mui/icons-material/People";
import Diversity3Icon from "@mui/icons-material/Diversity3";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    background: theme.palette.type === "dark" ? "#000" : "#f5f5f5",
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.type === "dark" ? "#fff" : "#000",
  },
  categoryTitle: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme.palette.type === "dark" ? "#fff" : "#777",
  },
  listItem: {
    "&:hover": {
      background: theme.palette.type === "dark" ? "#000" : "#f5f5f5",
    },
  },
  listIcon: {
    color: "#8601af",
  },
  accordion: {
    boxShadow: "none",
    "&:before": {
      display: "none",
    },
    backgroundColor: theme.palette.type === "dark" ? "#121212" : "#fafafa",
  },
  accordionSummary: {
    borderBottom: "1px solid #e0e0e0",
  },
}));

const Subjects = () => {
  const classes = useStyles();

  const highSchoolSubjects = [
    {
      name: "Mathematics",
      description: "Dealing with numbers and the logic of shapes.",
      icon: <NumbersIcon />,
    },
    {
      name: "Physical Science",
      description: "Study of matter, energy, and the fundamental forces.",
      icon: <ScienceIcon />,
    },
    {
      name: "Mathematical Literacy",
      description: "Understanding basic math concepts.",
      icon: <PercentIcon />,
    },
    {
      name: "Accounting",
      description: "Managing and analyzing financial information.",
      icon: <CalculateIcon />,
    },
    {
      name: "Life Science",
      description: "Exploring living organisms and life processes.",
      icon: <BiotechIcon />,
    },
    {
      name: "Business Studies",
      description: "Learning about business and entrepreneurship.",
      icon: <BusinessIcon />,
    },
    {
      name: "Geography",
      description:
        "Understanding the Earth's physical features and human activity.",
      icon: <TerrainIcon />,
    },
    {
      name: "English",
      description: "Studying English language and literature.",
      icon: <LanguageIcon />,
    },
    {
      name: "Afrikaans",
      description: "Studying Afrikaans language and literature.",
      icon: <LanguageIcon />,
    },
    {
      name: "IsiZulu",
      description: "Studying IsiZulu language and culture.",
      icon: <LanguageIcon />,
    },
    {
      name: "Sesotho",
      description: "Studying Sesotho language and culture.",
      icon: <LanguageIcon />,
    },
  ];

  const primarySchoolSubjects = [
    {
      name: "Mathematics",
      description: "Dealing with numbers and the logic of shapes.",
      icon: <NumbersIcon />,
    },
    {
      name: "Natural Sciences",
      description:
        "Study of matter, energy, and the fundamental forces.Exploring living organisms and life processes.",
      icon: <ScienceIcon />,
    },
    {
      name: "Life Skills",
      description:
        "abilities for adaptive and positive behavior that enable humans to deal effectively with the demands and challenges of life.",
      icon: <Diversity3Icon />,
    },
    {
      name: "Social Sciences",
      description:
        "Deals with human behaviour in its social and cultural aspects",
      icon: <PeopleIcon />,
    },
    {
      name: "English",
      description: "Studying English language and literature.",
      icon: <LanguageIcon />,
    },
    {
      name: "IsiZulu",
      description: "Studying IsiZulu language and culture.",
      icon: <LanguageIcon />,
    },
  ];

  const renderSubjects = (subjects) => (
    <List>
      {subjects.map((subject, index) => (
        <ListItem button key={index} className={classes.listItem}>
          <ListItemIcon className={classes.listIcon}>
            {subject.icon}
          </ListItemIcon>
          <ListItemText
            primary={subject.name}
            secondary={subject.description}
          />
        </ListItem>
      ))}
    </List>
  );

  return (
    <Paper className={classes.container} elevation={3}>
      <Typography variant="h4" className={classes.title}>
        Our Subjects
      </Typography>
      <Accordion className={classes.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.accordionSummary}
        >
          <Typography variant="h5" className={classes.categoryTitle}>
            High School
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {renderSubjects(highSchoolSubjects)}
        </AccordionDetails>
      </Accordion>
      <Accordion className={classes.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.accordionSummary}
        >
          <Typography variant="h5" className={classes.categoryTitle}>
            Primary School
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {renderSubjects(primarySchoolSubjects)}
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default Subjects;
